import styled, { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  /* Font imports - using link tag in index.html is more reliable than @import in CSS */
  // @import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700&family=Sen:wght@400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
  }

  html{
    height: calc(var(--vh, 1vh) * 100);
  }

  body {
    font-family: ${theme.fonts.primary};
    background-color: #fff;
    color: ${theme.colors.white};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.5;
    font-size: ${theme.fontSizes.base};
    // min-height: 100svh;
    // height: -webkit-fill-available;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  #root {
    height: 100svh;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
    outline: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1.2;
  }

  .circular-react-player {
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;
    border-radius: 50% !important;
    overflow: hidden !important;
  }

  /* This targets the actual video/iframe inside ReactPlayer */
  .circular-react-player video,
  .circular-react-player iframe {
    border-radius: 50% !important;
    object-fit: cover !important;
  }

  .page-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  .page-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 300ms, transform 300ms;
  }
  .page-exit {
    opacity: 1;
    transform: translateX(0);
  }
  .page-exit-active {
    opacity: 0;
    transform: translateX(-100%);
    transition: opacity 300ms, transform 300ms;
  }
  .spinner-container {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

  .spinner-circle {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 4px solid #000;
    border-color: #D179FB transparent #2F73EA transparent;
    animation: rotate 1.2s linear infinite;
    position: absolute;
    top: 0;
    left: 0;
  }

  .spinner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999999999999999999999;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`; 


export const AppContainer = styled.div`
  height: auto;
  // overflow: auto;
`;
